import { useCallback } from "react";

import { useSdk } from "hooks/useSdk";
import withAuthentication from "hooks/withAuth";

const useDeleteMessage = () => {
  const sdk = useSdk();

  /**
   * メッセージの取り消し
   */
  const deleteMessage = useCallback(
    async ({ messageId }: { messageId: string }) => {
      return await withAuthentication(async (idToken) => {
        const res = await sdk(idToken)
          .deleteMessage({
            messageId,
          })
          .catch((e) => {
            throw new Error(e);
          });
        if (res.messageDelete.userErrors && res.messageDelete.userErrors?.length > 0) {
          console.error(res.messageDelete.userErrors);
          throw new Error("失敗しました");
        }
        return res;
      });
    },
    [sdk]
  );

  return {
    deleteMessage,
  };
};

export default useDeleteMessage;
